export default "__VITE_PUBLIC_ASSET__e0d5ebc4__"